import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e6631d46"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ppe bg-white relative overflow-y-scroll" }
const _hoisted_2 = { class: "body" }
const _hoisted_3 = { class: "title-section-spacing sticky top-0 bg-white z-20" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-left text-primary-600 font-bold" }, "Indietro", -1))
const _hoisted_5 = { class: "title-row pt-6 pb-6 sticky top-0 bg-white" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "font-bold block text-left pb-4" }, "Gestione materiale richiesto", -1))
const _hoisted_7 = { class: "ppe-info text-primary-900 text-left bg-blue-200 p-4 rounded flex items-center" }
const _hoisted_8 = ["d"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "É necessario rigenerare il QR code ad ogni modifica del materiale richiesto.", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "street items-center flex" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "font-bold text-left subtitle" }, "Tutti i materiali creati")
], -1))
const _hoisted_11 = { class: "searchbar flex" }
const _hoisted_12 = { class: "ppe-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LeftArrow = _resolveComponent("LeftArrow")!
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_WorkingSitePpeCard = _resolveComponent("WorkingSitePpeCard")!
  const _component_Loader = _resolveComponent("Loader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "header sticky top-0 bg-white w-full fixed relative inline-flex cursor-pointer",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
          }, [
            _createVNode(_component_LeftArrow, { class: "back-arrow" }),
            _hoisted_4
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(), _createElementBlock("svg", {
                class: _normalizeClass(["w-5 h-5 mr-3", `text-blue-600 sm:w-5 sm:h-5`]),
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", {
                  fill: "currentColor",
                  d: 'M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm.25,5a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12.25,5ZM14.5,18.5h-4a1,1,0,0,1,0-2h.75a.25.25,0,0,0,.25-.25v-4.5a.25.25,0,0,0-.25-.25H10.5a1,1,0,0,1,0-2h1a2,2,0,0,1,2,2v4.75a.25.25,0,0,0,.25.25h.75a1,1,0,1,1,0,2Z'
                }, null, 8, _hoisted_8)
              ])),
              _hoisted_9
            ])
          ]),
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _withDirectives(_createElementVNode("input", {
              class: "text px-4 py-3 flex-grow",
              type: "text",
              placeholder: "Scrivi qui il nome del materiale",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name) = $event))
            }, null, 512), [
              [_vModelText, _ctx.name]
            ]),
            _createVNode(_component_PrimaryButton, {
              class: "button bg-white text-primary flex-none",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onAddPpe()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Aggiungi")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ppes, (ppe) => {
              return (_openBlock(), _createBlock(_component_WorkingSitePpeCard, { "model-value": ppe }, null, 8, ["model-value"]))
            }), 256))
          ])
        ])
      ])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Loader, {
          key: 0,
          message: "Salvataggio..."
        }))
      : _createCommentVNode("", true)
  ], 64))
}